import gql from "graphql-tag";

export default gql`
  mutation BillingPortalUrl($flowDataType: BillingPortalFlowDataType) {
    billingPortalUrl(flowDataType: $flowDataType)
  }
`;
